import { type CartInfoParams, type GetCartInfoResponse, getCartInfo } from "@api/getCartInfo";
import { useQuery } from "@tanstack/react-query";

export const useGetCartInfo = (params: CartInfoParams | null, authToken: string | null = null) =>
  useQuery<GetCartInfoResponse, Error>({
    queryKey: ["cartInfo", params, authToken],
    queryFn: () => getCartInfo({ params: params!, authToken }),
    enabled: Boolean(params && params.items?.length > 0),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
  });
